module.exports = __webpack_public_path__ + "static/media/py.067050f6.png";